import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { apiClient } from '@/shared/services/apiConfig';
import { L2VPNCircuit, L2VPNSuggestion } from '@/shared/types/l2vpnTypes';
import { PaginatedResponse } from '@/shared/types/responseTypes';

// Use Account L2VPN Assignments Query
export const useAccountL2VPNCircuits = (enabled: boolean) => {
  return useQuery({
    queryKey: ['l2vpn-circuits'],
    queryFn: async () => {
      const response = await apiClient.get<PaginatedResponse<L2VPNCircuit>>(
        `/api/v1/l2vpn-circuits`
      );
      return response.data.results;
    },
    enabled: enabled
  });
};

/** Infinite scroll fetch for l2vpn circuits load-more. */
export const useInfiniteAccountL2VPNCircuits = () => {
  return useInfiniteQuery({
    queryKey: ['l2vpn-circuits-infinite'],
    queryFn: async ({ pageParam }: { pageParam: number }) => {
      const response = await apiClient.get<PaginatedResponse<L2VPNCircuit>>(
        `/api/v1/l2vpn-circuits`,
        { params: { page: pageParam } }
      );
      return response.data;
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, _pages, lastPageParam) =>
      lastPage.isLastPage ? undefined : lastPageParam + 1,
  });
};

// Get L2VPN Suggestions Query
export const useGetL2VPNSuggestions = (circuitIds: string[], enabled: boolean = false) => {
  return useQuery({
    queryKey: ['l2vpn-suggestions', circuitIds],
    queryFn: async () => {
      const response = await apiClient.get<PaginatedResponse<L2VPNSuggestion>>(
        `/api/v1/l2vpn-circuits/suggestions`,
        {
          params: {
            circuitIds: circuitIds.join(','),
          },
        }
      );
      return response.data.results;
    },
    enabled: enabled && circuitIds.length > 0,
  });
};
